import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons/faChevronUp';

function BackToTopButton() {
    const [showButton, setShowButton] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const next = window.scrollY > 200;
            // Avoid a re-render on every scroll tick — only when the
            // visible/hidden state actually flips.
            setShowButton((prev) => (prev === next ? prev : next));
        };

        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        showButton && (
            <button
                onClick={scrollToTop}
                style={{
                    position: 'fixed',
                    bottom: '60px',
                    right: '60px',
                    padding: '14px',
                    fontSize: '18px',
                    color: '#fff',
                    backgroundColor: '#0062a1',
                    border: 'none',
                    borderRadius: '50%',
                    cursor: 'pointer',
                    boxShadow: '0 1px 4px rgba(0,0,0,0.18)',
                }}
                aria-label="Back to top"
            >
                <FontAwesomeIcon icon={faChevronUp} />
            </button>
        )
    );
}

export default BackToTopButton;
